export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-3xl border border-background-200/70 p-8 md:p-12">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              联系与投稿
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-md mx-auto">
              欢迎提供线索、投稿爆料或商务合作，我们期待与你共建瓜田
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="flex flex-col items-center text-center p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-500 mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">爆料投稿</h3>
              <p className="text-xs text-foreground-500">tips@51chigua.com</p>
            </div>
            <div className="flex flex-col items-center text-center p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100/70 text-accent-500 mb-3">
                <i className="ri-briefcase-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">biz@51chigua.com</p>
            </div>
            <div className="flex flex-col items-center text-center p-5 rounded-xl bg-background-100 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-200/70 text-secondary-600 mb-3">
                <i className="ri-question-answer-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1">意见反馈</h3>
              <p className="text-xs text-foreground-500">feedback@51chigua.com</p>
            </div>
          </div>

          <div className="text-center pt-6 border-t border-background-200/70">
            <p className="text-xs text-foreground-500 leading-relaxed">
              五一吃瓜网欢迎每一位热爱吃瓜的朋友。如有线索爆料、内容投稿或商务合作需求，
              请通过上方邮箱与我们联系，我们将在 24 小时内回复。同时也欢迎通过邮件提出宝贵意见，
              帮助我们不断优化吃瓜体验。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}